export var ENERGY_CLASS;
(function (ENERGY_CLASS) {
  ENERGY_CLASS[ENERGY_CLASS["HIGH"] = 1] = "HIGH";
  ENERGY_CLASS[ENERGY_CLASS["MEDIUM"] = 2] = "MEDIUM";
  ENERGY_CLASS[ENERGY_CLASS["LOW"] = 3] = "LOW";
})(ENERGY_CLASS || (ENERGY_CLASS = {}));